import { fetchFactory } from 'Libs/http/utils';

type MagicCodeResponse = {
  audienceGroupId: number;
};

export const upsertMagicCode = (code: string, audienceGroupId?: number) => {
  const { fetchFn } = fetchFactory<MagicCodeResponse>({
    route: '/api/audiences/groups/magic-code',
    method: 'POST',
    payload: {
      code,
      audienceGroupId,
    },
  });

  return fetchFn();
};

type EmailListReponse = {
  audienceGroupId: number;
};

export const updateEmailList = (
  emailList: {
    addedEmails: string[];
    removedEmails: string[];
  },
  audienceGroupId: number,
) => {
  const { fetchFn } = fetchFactory<EmailListReponse>({
    route: `/api/audiences/groups/${audienceGroupId}/email-list`,
    method: 'PUT',
    payload: {
      addedEmails: emailList.addedEmails,
      removedEmails: emailList.removedEmails,
    },
  });
  return fetchFn();
};

export const createEmailList = (emailList: string[]) => {
  const { fetchFn } = fetchFactory<EmailListReponse>({
    route: '/api/audiences/groups/email-list',
    method: 'POST',
    payload: {
      emails: emailList,
    },
  });
  return fetchFn();
};

export const deleteAudienceGroup = (audienceGroupId: number) => {
  const { fetchFn } = fetchFactory<EmailListReponse>({
    route: `/api/audiences/groups/${audienceGroupId}`,
    method: 'DELETE',
  });

  return fetchFn();
};

export const upsertTargetingAudience = (entityId: number, targetedEntityId: number) => {
  const { fetchFn } = fetchFactory<MagicCodeResponse>({
    route: `/api/audiences/activity/${entityId}/link`,
    method: 'POST',
    payload: {
      targetedEntityType: 'activity',
      targetedEntityId,
    },
  });

  return fetchFn();
};
